export default {
  default: {
    host: process.env.DB_HOST,
    user: process.env.DB_USER,
    pass: process.env.DB_PASS,
    db: process.env.DB_NAME,
    remote_host: process.env.REMOTE_DB_HOST,
    remote_user: process.env.REMOTE_DB_USER,
    remote_pass: process.env.REMOTE_DB_PASS,
    remote_db: process.env.REMOTE_DB_NAME
  },
  states: {
    host: process.env.DB_STATES_HOST,
    user: process.env.DB_STATES_USER,
    pass: process.env.DB_STATES_PASS,
    db: process.env.DB_STATES_NAME
  },
  specifications: {
    host: process.env.DB_SPECIFICATIONS_HOST,
    user: process.env.DB_SPECIFICATIONS_USER,
    pass: process.env.DB_SPECIFICATIONS_PASS,
    db: process.env.DB_SPECIFICATIONS_NAME,
    remote_host: process.env.REMOTE_DB_SPECIFICATIONS_HOST,
    remote_user: process.env.REMOTE_DB_SPECIFICATIONS_USER,
    remote_pass: process.env.REMOTE_DB_SPECIFICATIONS_PASS,
    remote_db: process.env.REMOTE_DB_SPECIFICATIONS_NAME
  },
  winners: {
    host: process.env.DB_WINNERS_HOST,
    user: process.env.DB_WINNERS_USER,
    pass: process.env.DB_WINNERS_PASS,
    db: process.env.DB_WINNERS_NAME,
    remote_host: process.env.REMOTE_DB_WINNERS_HOST,
    remote_user: process.env.REMOTE_DB_WINNERS_USER,
    remote_pass: process.env.REMOTE_DB_WINNERS_PASS,
    remote_db: process.env.REMOTE_DB_WINNERS_NAME
  },
  docs: {
    host: process.env.DB_DOCS_HOST,
    user: process.env.DB_DOCS_USER,
    pass: process.env.DB_DOCS_PASS,
    db: process.env.DB_DOCS_NAME,
    remote_host: process.env.REMOTE_DB_DOCS_HOST,
    remote_user: process.env.REMOTE_DB_DOCS_USER,
    remote_pass: process.env.REMOTE_DB_DOCS_PASS,
    remote_db: process.env.REMOTE_DB_DOCS_NAME
  },
  logs: {
    host: process.env.DB_LOGS_HOST,
    user: process.env.DB_LOGS_USER,
    pass: process.env.DB_LOGS_PASS,
    db: process.env.DB_LOGS_NAME,
    remote_host: process.env.REMOTE_DB_LOGS_HOST,
    remote_user: process.env.REMOTE_DB_LOGS_USER,
    remote_pass: process.env.REMOTE_DB_LOGS_PASS,
    remote_db: process.env.REMOTE_DB_LOGS_NAME
  },
  surveys: {
    host: process.env.DB_SURVEYS_HOST,
    user: process.env.DB_SURVEYS_USER,
    pass: process.env.DB_SURVEYS_PASS,
    db: process.env.DB_SURVEYS_NAME,
    remote_host: process.env.REMOTE_DB_SURVEYS_HOST,
    remote_user: process.env.REMOTE_DB_SURVEYS_USER,
    remote_pass: process.env.REMOTE_DB_SURVEYS_PASS,
    remote_db: process.env.REMOTE_DB_SURVEYS_NAME
  },
  surveys_docs: {
    host: process.env.DB_SURVEYS_DOCS_HOST,
    user: process.env.DB_SURVEYS_DOCS_USER,
    pass: process.env.DB_SURVEYS_DOCS_PASS,
    db: process.env.DB_SURVEYS_DOCS_NAME,
    remote_host: process.env.REMOTE_DB_SURVEYS_DOCS_HOST,
    remote_user: process.env.REMOTE_DB_SURVEYS_DOCS_USER,
    remote_pass: process.env.REMOTE_DB_SURVEYS_DOCS_PASS,
    remote_db: process.env.REMOTE_DB_SURVEYS_DOCS_NAME
  },
  config: {
    host: process.env.DB_CONFIGURATIONS_HOST,
    user: process.env.DB_CONFIGURATIONS_USER,
    pass: process.env.DB_CONFIGURATIONS_PASS,
    db: process.env.DB_CONFIGURATIONS_NAME,
    remote_host: process.env.REMOTE_DB_CONFIGURATIONS_HOST,
    remote_user: process.env.REMOTE_DB_CONFIGURATIONS_USER,
    remote_pass: process.env.REMOTE_DB_CONFIGURATIONS_PASS,
    remote_db: process.env.REMOTE_DB_CONFIGURATIONS_NAME
  }
}



// WEBPACK FOOTER //
// ./src/config/connections.js